/* L4V v273I — review carousel stable touch/resume loop
   Base: v273G. Scope: #l4v-review-showcase only.
   Desktop: premium continuous transform loop.
   Mobile/tablet/landscape: native horizontal touch scroll + JS auto-scroll that resumes after interaction. */
(function(){
  'use strict';

  var mqDesktop = window.matchMedia ? window.matchMedia('(min-width: 992px)') : null;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function isDesktop(){ return !mqDesktop || mqDesktop.matches; }
  function reduceMotion(){ return !!(mqReduce && mqReduce.matches); }

  function initReviewLoop(root){
    var scope = root || document;
    var scroller = scope.querySelector('#l4v-review-showcase [data-l4v-reviews-slider], #l4v-review-showcase .l4v-reviews-marquee-v28, #l4v-review-showcase .l4v-reviews-static-v28');
    if(!scroller || scroller.dataset.l4vV273I === '1') return;

    var track = scroller.querySelector('.l4v-reviews-track-v28');
    if(!track) return;

    scroller.dataset.l4vV273I = '1';
    scroller.dataset.l4vV134Auto = '1';
    scroller.dataset.l4vV135Auto = '1';
    scroller.dataset.l4vV259Loop = '1';

    var raf = null;
    var running = false;
    var x = 0;
    var lastTs = null;
    var loopWidth = 0;
    var desktopSpeed = 22;
    var mobileSpeed = 18;
    var mode = null;
    var interacting = false;
    var resumeTimer = null;
    var wrapping = false;

    function measure(){
      var cards = track.querySelectorAll('.l4v-review-card');
      if(cards.length >= 7){
        loopWidth = Math.max(1, cards[6].offsetLeft - cards[0].offsetLeft);
      } else {
        loopWidth = Math.max(1, track.scrollWidth / 2);
      }
    }

    function stop(){
      if(raf) cancelAnimationFrame(raf);
      raf = null;
      running = false;
      lastTs = null;
    }

    function clearResume(){
      if(resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = null;
    }

    function resetStyles(){
      stop();
      clearResume();
      x = 0;
      lastTs = null;
      interacting = false;
      wrapping = false;
      track.style.transform = '';
      track.style.willChange = '';
      track.style.animation = '';
      scroller.style.overflowX = '';
      scroller.style.overflowY = '';
    }

    function bindInteraction(){
      if(scroller.dataset.l4vV273IInteractions === '1') return;
      scroller.dataset.l4vV273IInteractions = '1';

      function pauseBriefly(){
        interacting = true;
        clearResume();
      }
      function resumeSoon(){
        clearResume();
        resumeTimer = window.setTimeout(function(){ interacting = false; lastTs = null; }, 1600);
      }

      scroller.addEventListener('touchstart', pauseBriefly, {passive:true});
      scroller.addEventListener('touchend', resumeSoon, {passive:true});
      scroller.addEventListener('touchcancel', resumeSoon, {passive:true});
      scroller.addEventListener('pointerdown', function(e){ if(e.pointerType !== 'mouse') pauseBriefly(); }, {passive:true});
      scroller.addEventListener('pointerup', function(e){ if(e.pointerType !== 'mouse') resumeSoon(); }, {passive:true});
      scroller.addEventListener('pointercancel', function(e){ if(e.pointerType !== 'mouse') resumeSoon(); }, {passive:true});
      scroller.addEventListener('mousedown', pauseBriefly, {passive:true});
      scroller.addEventListener('mouseup', resumeSoon, {passive:true});
      scroller.addEventListener('mouseleave', resumeSoon, {passive:true});
      scroller.addEventListener('wheel', function(){ pauseBriefly(); resumeSoon(); }, {passive:true});

      scroller.addEventListener('scroll', function(){
        if(mode !== 'mobile' || wrapping || !loopWidth || loopWidth < 10) return;
        var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        if(maxScroll < 10) return;

        /* The track contains two identical sets. Keep the scroll position inside the first set,
           so review 6 flows back to review 1 instead of reaching a hard end. */
        if(scroller.scrollLeft >= loopWidth){
          wrapping = true;
          scroller.scrollLeft = scroller.scrollLeft - loopWidth;
          window.setTimeout(function(){ wrapping = false; }, 40);
        } else if(scroller.scrollLeft < 0){
          wrapping = true;
          scroller.scrollLeft = scroller.scrollLeft + loopWidth;
          window.setTimeout(function(){ wrapping = false; }, 40);
        }
      }, {passive:true});
    }

    function desktopTick(ts){
      if(!running || mode !== 'desktop') return;
      if(document.hidden || reduceMotion()){
        lastTs = ts;
        raf = requestAnimationFrame(desktopTick);
        return;
      }
      if(lastTs == null) lastTs = ts;
      var dt = Math.min(48, ts - lastTs) / 1000;
      lastTs = ts;
      if(!loopWidth || loopWidth < 10) measure();
      x += desktopSpeed * dt;
      if(loopWidth > 0 && x >= loopWidth) x = x % loopWidth;
      track.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
      raf = requestAnimationFrame(desktopTick);
    }

    function mobileTick(ts){
      if(!running || mode !== 'mobile') return;
      if(document.hidden || reduceMotion() || interacting){
        lastTs = ts;
        raf = requestAnimationFrame(mobileTick);
        return;
      }
      if(lastTs == null) lastTs = ts;
      var dt = Math.min(48, ts - lastTs) / 1000;
      lastTs = ts;
      if(!loopWidth || loopWidth < 10) measure();
      if(loopWidth > 0){
        var nextLeft = scroller.scrollLeft + (mobileSpeed * dt);
        if(nextLeft >= loopWidth) nextLeft = nextLeft - loopWidth;
        scroller.scrollLeft = nextLeft;
      }
      raf = requestAnimationFrame(mobileTick);
    }

    function startDesktop(){
      mode = 'desktop';
      measure();
      scroller.scrollLeft = 0;
      scroller.style.overflowX = 'hidden';
      scroller.style.overflowY = 'visible';
      track.style.animation = 'none';
      track.style.willChange = 'transform';
      track.style.transform = 'translate3d(0,0,0)';
      running = true;
      lastTs = null;
      raf = requestAnimationFrame(desktopTick);
    }

    function startMobile(){
      mode = 'mobile';
      measure();
      scroller.style.overflowX = 'auto';
      scroller.style.overflowY = 'visible';
      track.style.animation = 'none';
      track.style.transform = 'none';
      track.style.willChange = 'auto';
      if(scroller.scrollLeft >= loopWidth && loopWidth > 10){ scroller.scrollLeft = scroller.scrollLeft % loopWidth; }
      bindInteraction();
      running = true;
      lastTs = null;
      raf = requestAnimationFrame(mobileTick);
    }

    function start(){
      resetStyles();
      if(isDesktop()) startDesktop(); else startMobile();
    }

    function restart(){
      resetStyles();
      window.setTimeout(start, 80);
    }

    window.addEventListener('resize', restart, {passive:true});
    window.addEventListener('orientationchange', restart, {passive:true});
    document.addEventListener('visibilitychange', function(){ lastTs = null; interacting = false; });

    window.setTimeout(start, 60);
    window.setTimeout(restart, 700);
    window.setTimeout(restart, 1800);
  }

  function init(){ initReviewLoop(document); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(e){ initReviewLoop(e.target || document); });
})();
